<script>
export default {
  /**
  TODO: implement rstTmo
  */
  name: "IgButton",
  props: {
    okFunc: {
      default: null
    },
    iconLeft: {
      default: null
    },
    clkTmo: {
      default: 1000
    },
    rstTmo: {
      default: null
    }
  },
  data() {
    return {
      saveSt: 0,
      disabled: false,
      dTmo1: null
    };
  },
  methods: {
    dTmFunc() {
      this.disabled = true;
      let s = this.clkTmo;
      if (s < 1) return;
      if (this.dTmo1) clearTimeout(this.dTmo1);
      this.dTmo1 = setTimeout(() => {
        this.disabled = false;
      }, s);
    },
    async save1() {
      try {
        let r=await this.okFunc();
        this.saveSt = 5;
        this.dTmFunc();
        this.$emit("ok",r);
      } catch (e) {
        console.log("okFunc.e: " + e.message);
        this.saveSt = -1;
        this.dTmFunc();
        this.$emit("fail",e);
      }
    },
    save() {
      if (typeof this.okFunc !== "function") return;
      if (this.saveSt == 1 || this.disabled) return;
      this.saveSt = 1;
      setTimeout(() => {
        this.save1();
      }, 100);
    }
  }
};
</script>
<template>
  <b-field :type="saveSt == 5 ? 'is-success' : saveSt < 0 ? 'is-danger' : ''">
    <b-button
      @click="save"
      :disabled="disabled"
      :icon-left="iconLeft"
      :type="saveSt == 5 ? 'is-success' : saveSt < 0 ? 'is-danger' : ''"
      :loading="saveSt == 1"
      ><slot> </slot
    ></b-button>
  </b-field>
</template>
